import { getRisktypeAPI } from '../sevices/commonService';

export const getAllRiskType = (token) => async (dispatch) => {
    await dispatch(getRisktypeAPI(token));
};